import React, { Component } from "react";

import{ QRCodeSVG} from 'qrcode.react';

export default class PrintLabels extends Component {
  render() {
    var id = this.props.output.id;
    let break_after = {
      display: "block",
      pageBreakAfter: "always",
      position: "relative",
      marginTop: "2mm",
    };

    let fontSize = { fontSize: "13px" };
    let midFontSize = { fontSize: "16px" };
    let bigFontSize = { fontSize: "19px" };
    let alreadyPrinted = this.props.alreadyPrinted ? "alreadyPrinted" : "";
    return (
      <div className="toPrint" id={"toPrint" + this.props.index + alreadyPrinted}>
        <div id={"myCanvas" + this.props.index + alreadyPrinted}>
          <QRCodeSVG value={id.toString()} />
        </div>
        <div style={fontSize}>
          <div style={bigFontSize}>
            <b>ID: </b>
            {id}
          </div>
          <div>
            <b>Lot Id:</b>
            {this.props.session ? this.props.session : "-"}
          </div>
          <div>
            <b>Exp:</b>
            {this.props.output.expiration_date ? this.props.output.expiration_date : "-"}
          </div>
          <div>
            <b>Vendor:</b>
            {this.props.vendor ? this.props.vendor : "No vendor"}
          </div>
          <div>
            <b>Brand:</b>
            {this.props.output.brand ? this.props.output.brand.brand_name : "-"}
          </div>
          <div>
            <b>Packing-date:</b>
            {this.props.output.packing_date ? this.props.output.packing_date : "-"}
          </div>
          <div style={midFontSize}>
            <b style={fontSize}>Item:</b>
            {this.props.output.item.name} :{" "}
            {this.props.output.extra_info ? (this.props.output.extra_info.grade ? this.props.output.extra_info.grade.grade : "N/A") : "N/A"}{" "}
          </div>
          <div>
            <b>Contains:</b>
            {this.props.output.item.allergies ? this.props.output.item.allergies : "-"}
          </div>
          <div>
            <b>Ingredients:</b>
            {this.props.output.item.ingredients ? this.props.output.item.ingredients : "-"}
          </div>
          <div>
            <b>Quantity:</b>
            {this.props.output.weight ? this.props.output.weight : "-"}
          </div>
          <div>
            <b>Count:</b>
            {this.props.output.number_items ? this.props.output.number_items : "-"}
          </div>
        </div>
        <div style={break_after}></div>
      </div>
    );
  }
}
